import type { CheckoutContextValue } from 'src/types/checkout';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const CampaignContext = createContext<CheckoutContextValue | undefined>(undefined);
